import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type StatusChipVariant = 'neutral' | 'info' | 'warning' | 'success' | 'danger';

@Component({
  selector: 'ui-atom-status-chip',
  standalone: true,
  imports: [],
  templateUrl: './ui-atom-status-chip.component.html',
  styleUrl: './ui-atom-status-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAtomStatusChipComponent {
  @Input() label = '';
  @Input() variant: StatusChipVariant = 'neutral';
}
